


// import React from "react";
// import "../css/contact.css";

// const ContactInfo = () => {
//   return (
//     <>

    //  <section className="page-banner">
    //   <div className="page-banner-container">
    //     <h2>
    //       Contact Us
    //     </h2>
    //   </div>
    // </section>
//       <section className="contact-section">

//         <div className="container">

//           <div className="row justify-content-center">

//             {/* Phone */}
//             <div className="col-lg-4 col-md-6 mb-4">

//               <div className="contact-box">

//                 <div className="contact-icon">
//                   <i className="fas fa-phone-alt"></i>
//                 </div>

//                 <div className="contact-content">

//                   <h4>Phone Support</h4>

//                   <p>
//                     <a href="tel:+918355835813">
//                       +91 83558 35813
//                     </a>
//                   </p>

//                   <p>
//                     <a href="tel:+919930929439">
//                       +91 99309 29439
//                     </a>
//                   </p>

//                   <p>
//                     <a href="tel:+919022432779">
//                       +91 90224 32779
//                     </a>
//                   </p>

//                   <span>24×7 Travel Assistance</span>

//                 </div>

//               </div>

//             </div>

//             {/* Email */}

//             <div className="col-lg-4 col-md-6 mb-4">

//               <div className="contact-box">

//                 <div className="contact-icon">
//                   <i className="fas fa-envelope"></i>
//                 </div>

//                 <div className="contact-content">

//                   <h4>Email Support</h4>

//                   <p>
//                     <a href="mailto:booking@shreeshatravels.com">
//                       booking@shreeshatravels.com
//                     </a>
//                   </p>

//                   <span>Reply Within 24 Hours</span>

//                 </div>

//               </div>

//             </div>

//             {/* Address */}

//             <div className="col-lg-4 col-md-6 mb-4">

//               <div className="contact-box">

//                 <div className="contact-icon">
//                   <i className="fas fa-map-marker-alt"></i>
//                 </div>

//                 <div className="contact-content">

//                   <h4>Office Address</h4>

//                   <p>
//                     <strong>Shreesha Tours & Travels</strong>
//                     <br />
//                     Office 125, Saishraddha CHS,
//                     <br />
//                     Plot No.47,
//                     <br />
//                     Near Koparkhairane Police Station,
//                     <br />
//                     Sector 5, Ghansoli,
//                     <br />
//                     Navi Mumbai,
//                     Maharashtra - 400701
//                   </p>

//                 </div>

//               </div>

//             </div>

//           </div>

//           {/* Google Map */}

//           <div className="row">

//             <div className="col-lg-12">

//               <div className="map-box">

// <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d91890.02094960261!2d72.85692930221559!3d19.114366282041622!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c1b888e5e255%3A0xd9139f78b8e4feac!2sShreesha%20tours%20%26%20travels!5e1!3m2!1sen!2sin!4v1786159198880!5m2!1sen!2sin" width="100%" height="450"  allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>

//               </div>

//             </div>

//           </div>

//         </div>

//       </section>
//     </>
//   );
// };

// export default ContactInfo;












import React from "react";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaArrowRight,
  FaWhatsapp,
} from "react-icons/fa";

import "../css/contact.css";

const ContactInfo = () => {
  return (
    <>
      {/* ================= PAGE BANNER ================= */}
          <section className="page-banner">
      <div className="page-banner-container">
        <h2>
          Contact Us
        </h2>
      </div>
    </section>


      {/* ================= CONTACT SECTION ================= */}
      <section className="stc-contact-section">

        <div className="stc-contact-container">

          {/* ================= SECTION HEADING ================= */}
          <div className="stc-section-heading">

            <span className="stc-section-label">
              GET IN TOUCH
            </span>

            <h2>
              Let's Plan Your <span>Journey</span>
            </h2>

            <p>
              Whether you need a local cab, airport transfer,
              or outstation taxi, our team is ready to assist you.
            </p>

          </div>


          {/* ================= CONTACT CARDS ================= */}
          <div className="stc-contact-grid">

            {/* Phone */}
            <div className="stc-contact-card stc-phone-card">

              <div className="stc-card-top">
                <div className="stc-contact-icon">
                  <FaPhoneAlt />
                </div>

                <span className="stc-card-badge">
                  24×7
                </span>
              </div>

              <div className="stc-contact-content">

                <h3>Phone Support</h3>

                <p className="stc-card-description">
                  Call our travel experts anytime for
                  booking and assistance.
                </p>

                <div className="stc-contact-details">

                  <a href="tel:+918355835813">
                    +91 83558 35813
                  </a>

                  <a href="tel:+919930929439">
                    +91 99309 29439
                  </a>

                  <a href="tel:+919022432779">
                    +91 90224 32779
                  </a>

                </div>

                <div className="stc-card-bottom">
                  <span>
                    <FaClock />
                    24×7 Travel Assistance
                  </span>
                </div>

              </div>

            </div>


            {/* Email */}
            <div className="stc-contact-card stc-email-card">

              <div className="stc-card-top">

                <div className="stc-contact-icon">
                  <FaEnvelope />
                </div>

                <span className="stc-card-badge">
                  EMAIL
                </span>

              </div>

              <div className="stc-contact-content">

                <h3>Email Support</h3>

                <p className="stc-card-description">
                  Send us your travel requirements and
                  our team will get back to you.
                </p>

                <div className="stc-contact-details">

                  <a href="mailto:booking@shreeshatravels.com">
                    booking@shreeshatravels.com
                  </a>

                </div>

                <div className="stc-card-bottom">
                  <span>
                    <FaClock />
                    Reply Within 24 Hours
                  </span>
                </div>

              </div>

            </div>


            {/* Address */}
            <div className="stc-contact-card stc-location-card">

              <div className="stc-card-top">

                <div className="stc-contact-icon">
                  <FaMapMarkerAlt />
                </div>

                <span className="stc-card-badge">
                  OFFICE
                </span>

              </div>

              <div className="stc-contact-content">

                <h3>Office Address</h3>

                <p className="stc-card-description">
                  Visit our office for bookings,
                  inquiries, and travel assistance.
                </p>

                <address className="stc-address">
                  <strong>
                    Shreesha Tours & Travels
                  </strong>

                  <br />

                  Office 125, Saishraddha CHS,
                  

                  Plot No. 47,
                  

                  Near Koparkhairane Police Station,
                 

                  Sector 5, Ghansoli,
                 
                  Navi Mumbai,
                 

                  Maharashtra - 400701
                </address>

                <div className="stc-card-bottom">
                  <span>
                    <FaMapMarkerAlt />
                    Navi Mumbai, Maharashtra
                  </span>
                </div>

              </div>

            </div>

          </div>


          {/* ================= MAP + INFO ================= */}
          <div className="stc-map-section">

            <div className="stc-map-heading">

              <div>
                <span className="stc-section-label">
                  FIND US
                </span>

                <h2>
                  Visit Our <span>Office</span>
                </h2>
              </div>

              <a
                href="https://www.google.com/maps/search/?api=1&query=Shreesha+tours+%26+travels"
                target="_blank"
                rel="noopener noreferrer"
                className="stc-direction-btn"
              >
                Get Directions
                <FaArrowRight />
              </a>

            </div>


            <div className="stc-map-box">

              <iframe
                title="Shreesha Tours & Travels Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d91890.02094960261!2d72.85692930221559!3d19.114366282041622!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7c1b888e5e255%3A0xd9139f78b8e4feac!2sShreesha%20tours%20%26%20travels!5e1!3m2!1sen!2sin!4v1786159198880!5m2!1sen!2sin"
                loading="lazy"
                allowFullScreen
                referrerPolicy="strict-origin-when-cross-origin"
              />

            </div>

          </div>


          {/* ================= BOTTOM CTA ================= */}
          <div className="stc-contact-cta">

            <div className="stc-cta-icon">
              <FaWhatsapp />
            </div>

            <div className="stc-cta-content">

              <span>NEED QUICK ASSISTANCE?</span>

              <h3>
                Talk to our travel team today
              </h3>

              <p>
                Get instant assistance with bookings,
                fares, routes and travel plans.
              </p>

            </div>

            <a
              href="https://wa.me/919930929439?text=Hi%2C%20I%20would%20like%20to%20inquire%20about%20your%20travel%20services."
              target="_blank"
              rel="noopener noreferrer"
              className="stc-whatsapp-btn"
            >
              WhatsApp Us
              <FaArrowRight />
            </a>

          </div>

        </div>

      </section>
    </>
  );
};

export default ContactInfo;
